import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../actions';
import * as selectors from '../selectors';

import EditPermissionsModal from './EditPermissionsModal';
import ListingArray from './ListingArray';

const TabListings = ({ control, disabled, getValues, setValue }) => {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(null);

    const dispatch = useDispatch();
    const initializeAuthEmailsForm = (values) =>
        dispatch(actions.initializeAuthEmailsForm(values));
    const openEmailModal = (value) => dispatch(actions.openEmailModal(value));

    const isOpenEmailsModal = useSelector(selectors.getIsOpenEmailsModal);

    const handleOnHide = () => openEmailModal(false);

    const handleSaveEmails = ({ auth_emails }) => {
        setValue(
            `list_configs_protected.${currentIndex}.auth_emails`,
            auth_emails,
        );
        openEmailModal(false);
    };
    return (
        <>
            <ListingArray
                control={control}
                disabled={disabled}
                getValues={getValues}
                initializeAuthEmailsForm={initializeAuthEmailsForm}
                name="list_configs_opened"
                openEmailModal={openEmailModal}
                setCurrentIndex={setCurrentIndex}
                setValue={setValue}
                title={t('Opened')}
            />
            <ListingArray
                control={control}
                disabled={disabled}
                getValues={getValues}
                initializeAuthEmailsForm={initializeAuthEmailsForm}
                name="list_configs_protected"
                openEmailModal={openEmailModal}
                protectedList
                setCurrentIndex={setCurrentIndex}
                setValue={setValue}
                title={t('Protected', { count: 2 })}
            />
            <EditPermissionsModal
                callback={handleSaveEmails}
                isOpen={isOpenEmailsModal}
                onHide={handleOnHide}
            />
        </>
    );
};

TabListings.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    getValues: PropTypes.func,
    setValue: PropTypes.func,
};

export default TabListings;
